import DashboardService from 'services/dashboard.service';
import {
  getUserPlans,
  getUsersCurrentSubscriptionStatus,
} from 'services/user.service';

import * as actions from './actionsType';
import { handleError } from '../../util';

/* ---------------- DASHBOARD ---------------- */

const getDashboardSuccess = (data) => ({
  type: actions.DASHBOARD_SUCCESS,
  proprties: data.proprties,
  balance: data.balance,
  consumption: data.consumption,
  additional_widgets: data.additional_widgets,
});

export const getDashboard = (subAccountId = null) => {
  return (dispatch) => {
    dispatch({ type: actions.DASHBOARD_START });

    DashboardService.getDashboard(subAccountId)
      .then((response) => {
        dispatch(getDashboardSuccess(response.data));
      })
      .catch((error) => {
        dispatch({
          type: actions.DASHBOARD_FAILED,
          errorMsg: handleError(error),
        });
      });
  };
};

/* ---------------- USER PLANS ---------------- */

const getMyPlansSuccess = (data) => ({
  type: actions.USER_PLANS_SUCCESS,
  userPlans: data,
});

export const getMyPlans = () => {
  return (dispatch) => {
    getUserPlans()
      .then((response) => {
        dispatch(getMyPlansSuccess(response.data));
      })
      .catch((error) => {
        dispatch({
          type: actions.USER_PLANS_FAILED,
          errorMsg: handleError(error),
        });
      });
  };
};

/* ---------------- SUBSCRIPTION ---------------- */

const getUserSubscriptionSuccess = (data) => ({
  type: actions.USER_SUBSCRIPTION_SUCCESS,
  currentSubscriptionStatus: data,
});

export const getUserCurrentSubscriptionStatus = () => {
  return (dispatch) => {
    dispatch({ type: actions.USER_SUBSCRIPTION_START });

    getUsersCurrentSubscriptionStatus()
      .then((response) => {
        dispatch(getUserSubscriptionSuccess(response.data));
      })
      .catch((error) => {
        dispatch({
          type: actions.USER_SUBSCRIPTION_FAILED,
          errorMsg: handleError(error),
        });
      });
  };
};

/* ---------------- INITIAL DASHBOARD ---------------- */

export const initialUserDashboardSuccess = (dashboard, plans) => ({
  type: actions.INITIAL_USER_DASHBOARD_SUCCESS,
  proprties: dashboard.proprties,
  balance: dashboard.balance,
  consumption: dashboard.consumption,
  additional_widgets: dashboard.additional_widgets,
  userPlans: plans,
  subscriptionType: dashboard.proprties?.subscription_type,
});

export const initialUserDashboard = (subAccountId = null) => {
  return async (dispatch) => {
    dispatch({ type: actions.INITIAL_USER_DASHBOARD_START });

    try {
      const [dashboardRes, plansRes] = await Promise.all([
        DashboardService.getDashboard(subAccountId),
        getUserPlans(),
        getUsersCurrentSubscriptionStatus(),
      ]);

      dispatch(initialUserDashboardSuccess(dashboardRes.data, plansRes.data));
    } catch (error) {
      dispatch({
        type: actions.INITIAL_USER_DASHBOARD_FAILED,
        errorMsg: handleError(error),
      });
    }
  };
};

/* ---------------- MESSAGES & RESET ---------------- */

export const setSuccessMessage = (data) => ({
  type: actions.USER_DASHBOARD_SUCCESS_MESSAGE,
  successMessage: data,
});

export const setErrorMessage = (data) => ({
  type: actions.USER_DASHBOARD_ERROR_MESSAGE,
  errorMessage: data,
});

export const clearDashboardMessage = () => ({
  type: actions.CLEAR_USER_DASHBOARD_MESSAGE,
});

export const resetUserInfo = () => ({
  type: actions.USER_PLANS_RESET,
});
